import { render } from "./ModalPodcastLayout.vue?vue&type=template&id=647d05c7"
import script from "./ModalPodcastLayout.vue?vue&type=script&lang=js"
export * from "./ModalPodcastLayout.vue?vue&type=script&lang=js"

import "./ModalPodcastLayout.vue?vue&type=style&index=0&id=647d05c7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__